import { ActivityParentEntityId } from "@sp-crm/core";
import { ActivityEntityType } from "components/entity-activity/types";
import { AntiFeature, Feature } from "components/feature";
import { Notes } from "components/notes/index";
import React from "react";
import { UnifiedTimeline } from "./unified-timeline";

interface InteractionNotesProps {
    entityId: ActivityParentEntityId;
    entityType: ActivityEntityType;
}

export const InteractionNotes: React.FC<InteractionNotesProps> = props => {
    const { entityId, entityType } = props;
    return (
        <>
            <Feature name="unifiedTimeline">
                <UnifiedTimeline entityId={entityId} entityType={entityType} />
            </Feature>
            <AntiFeature name="unifiedTimeline">
                <Notes entityId={entityId} entityType={entityType} />
            </AntiFeature>
        </>
    );
};
